export const ROCKETS_URL = 'https://api.spacexdata.com/v3/rockets';
const MISSIONS_API = 'https://api.spacexdata.com/v3/missions';
export default MISSIONS_API;
